import { GradPlanningMetricCtrl } from './grad-planning-metric.controller';

export const GradPlanningMetricComponent = {
  controller: GradPlanningMetricCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./grad-planning-metric.html'),
};
